import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, List, ListItem, ListItemButton, ListItemText,
  Typography, Box, Chip, InputAdornment, IconButton, CircularProgress,
} from '@mui/material';
import { Search as SearchIcon, Close as CloseIcon, Add as AddIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../redux/actions';
import { DevWinBadge } from '../DevPageBadge';

export default function ItemTemplateModal({ open, onClose, onSelect }) {
  const dispatch = useDispatch();
  const { rows = [], isLoading } = useSelector((s) => s.itemTemplate);
  const [q, setQ] = useState('');

  useEffect(() => {
    if (open) dispatch(actions.itemTemplateAll({ q: '', limit: 100 }));
  }, [open, dispatch]);

  const filtered = rows.filter((t) =>
    !q || t.name?.toLowerCase().includes(q.toLowerCase()) || t.description?.toLowerCase().includes(q.toLowerCase()),
  );

  return (
    <>
    <DevWinBadge num={145} name="ItemTemplateModal" open={open} />
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        <Typography fontWeight={700}>เลือกแม่แบบรายการ</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="ค้นหา..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
          sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
        />
        {isLoading ? (
          <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress /></Box>
        ) : filtered.length === 0 ? (
          <Typography color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>ไม่พบแม่แบบ</Typography>
        ) : (
          <List dense disablePadding>
            {filtered.map((t) => (
              <ListItem key={t._id} disablePadding divider>
                <ListItemButton onClick={() => onSelect(t)} sx={{ borderRadius: 1 }}>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="body2" fontWeight={600}>{t.name}</Typography>
                        {t.category && <Chip label={t.category} size="small" variant="outlined" />}
                      </Box>
                    }
                    secondary={
                      <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                        {t.description}
                      </Typography>
                    }
                  />
                  <Box sx={{ textAlign: 'right', ml: 2, minWidth: 80 }}>
                    <Typography variant="caption" color="text.secondary">{t.default_unit}</Typography>
                    <Typography variant="body2" fontWeight={600} color="primary">
                      {Number(t.default_price || 0).toLocaleString('th-TH')}
                    </Typography>
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }}>ปิด</Button>
      </DialogActions>
    </Dialog>
    </>
  );
}
